export const agenda = {
  agendaDuration: 'durée',
  agendaCurtainCopy: 'Copier le lien',
  agendaCurtainFlag: 'Signaler le contenu',
  agendaCurtainFlagSent: 'Contenu signalé',
  agendaLinkCopied: 'Lien copié !',
  agendaStartsAt: 'Commence à ',
  agendaEndsAt: 'Se termine à ',
  agendaSpeakers: 'Orateurs',
  agendaSeeAllSpeakers: 'Voir tout',
  agendaAddToSchedule: 'Ajouter à mon emploi du temps',
  agendaRemoveFromSchedule: 'Retirer de mon emploi du temps',
  agendaAddedToSchedule: 'Ajouté à mon emploi du temps !',
  agendaRemovedFromSchedule: 'Retiré de mon emploi du temps !',
  agendaCalendar: 'Calendrier',
  agendaAddToCalendar: 'Ajouter au calendrier système ?',
  agendaCalendarSkip: 'Passer',
  agendaCalendarAdd: 'Ajouter',
  agendaNow: 'MAINTENANT',
  agendaModerators: 'Modérateurs'
}
